export default {
  setIdentificationType(state, payload) {
    state.identificationTypes = payload;
  },
};
